import React, { useState, useCallback, useEffect } from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'
import BigNumber from 'bignumber.js'

import { ButtonConfirmed } from '../../components/Button'
import { Card } from '../../components/bakery/styleds'
import Value from '../../components/Value/OnlyValue'
import { AutoRow } from '../../components/Row'
import Loader from '../../components/Loader'

import { useActiveWeb3React } from '../../hooks'
import useReward from '../../hooks/bakery/useReward'
import useUnstakeNFT from '../../hooks/bakery/useUnstakeNFT'
import { NFTTYPE } from '../../constants/bakery/nft'
import useEarnings from '../../hooks/bakery/useEarnings'
import { commonStakeERC721EarnERC20GetUserInfo } from '../../sushi/utils'
import { getBalanceNumber } from '../../utils/bakery/formatBalance'

const CardWrapper = styled.div`
  display: flex;
  font-family: Baloo Da;
  width: 892px;
  margin-bottom: 30px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column;
    align-items: center;
    width: auto;
  `}
`
const StakeCard = styled(Card)`
  flex: 1;
  color: ${({ theme }) => theme.primary1};
  text-align: center;
  padding: 24px 0;

  &:first-child {
    margin-right: 24px;
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
    &:first-child {
      margin: 0 0 24px 0;
    }
  `}
`
const AmountText = styled.div`
  color: ${({ theme }) => theme.bsText4};
  margin: 16px 0 24px;
`

export default function StakeGameBox ({stakedBalanceArr, lpTokenAddress, masterContract, type}: {stakedBalanceArr: any[], lpTokenAddress: any, masterContract: any, type: string}) {
  const { account } = useActiveWeb3React()
  const earnings = useEarnings(lpTokenAddress, type)

  const [stakeSuccess, setStakeSuccess] = useState(false)
  const [stakingPower, setStakedBalance] = useState(new BigNumber(0))
  const getStakeInfo = useCallback(async() => {
    const stakeInfo = await commonStakeERC721EarnERC20GetUserInfo(masterContract, lpTokenAddress, account)
    const length = new BigNumber(stakeInfo[2].length).times(new BigNumber(10).pow(18))
    setStakedBalance(length)
    setStakeSuccess(false)
  }, [account, lpTokenAddress, masterContract])

  useEffect(() => {
    getStakeInfo()
  }, [account, stakeSuccess, getStakeInfo, stakedBalanceArr])

  
  // harvest
  const { onReward } = useReward(lpTokenAddress, type)
  const [requestedHarvest, setRequestedHarvest] = useState(false)
  const handleHarvest = useCallback(async () => {
    try {
      setRequestedHarvest(true)
      await onReward()
    } catch (e) {
      console.log(e)
    }
    setRequestedHarvest(false)
  }, [onReward])

  // unstake all
  const { onUnstake } = useUnstakeNFT(lpTokenAddress, masterContract)
  const [requestedUnstakeBulk, setRequestedUnstakeBulk] = useState(false)
  const handleUnstakeBulk = useCallback(async () => {
    try {
      setRequestedUnstakeBulk(true)
      const tokenIds = stakedBalanceArr.map(item => {return item.tokenId})
      const txHash = await onUnstake(tokenIds)
      if (!txHash) {
        setRequestedUnstakeBulk(false)
      } else {
        setTimeout(() => {
          setRequestedUnstakeBulk(false)
        }, 6000)
      }
    } catch (e) {
      setRequestedUnstakeBulk(false)
      console.log(e)
    }
  }, [onUnstake, stakedBalanceArr])

  return (
    <CardWrapper>
      <StakeCard>
        <Text fontSize={16}>{[NFTTYPE.GAMEBOX].includes(type) ? 'TLM' : 'BAKE'} Earned</Text>
        <AmountText>
          <Text fontSize={36}>
            <Value decimals={3} value={getBalanceNumber(earnings, 4)} />
          </Text>
        </AmountText>
        <ButtonConfirmed
          onClick={handleHarvest}
          disabled={!account || earnings.lte(0) || requestedHarvest}
          fontSize={14}
          width={276}
          height={40}
          margin="0 auto"
          padding="0px 18px"
        >
          {requestedHarvest ? (
            <AutoRow gap="6px" justify="center">
              Collecting <Loader stroke="white" />
            </AutoRow>
          ) : (
            'Harvest'
          )}
        </ButtonConfirmed>
      </StakeCard>
      <StakeCard>
        <Text fontSize={16}>Staking Power</Text>
        <AmountText>
          <Text fontSize={36}>
            <Value value={getBalanceNumber(stakingPower)} />
          </Text>
        </AmountText>
        <ButtonConfirmed
          onClick={handleUnstakeBulk}
          disabled={requestedUnstakeBulk || stakingPower.lte(0)}
          fontSize={14}
          width={276}
          height={40}
          margin="0 auto"
          padding="0px 18px"
        >
          {requestedUnstakeBulk ? (
            <AutoRow gap="6px" justify="center">
              Unstaking <Loader stroke="white" />
            </AutoRow>
          ) : (
            'Unstake'
          )}
        </ButtonConfirmed>
      </StakeCard>
    </CardWrapper>
  )
}